import { AnimatedNumber } from "../animated-number";
import { Helpers } from "../helpers/helpers";

export class StatWidget {
	constructor() {
		this.init();
	}

	async init() {
		const self = this;
		await Helpers.waitForElementToLoad('.stat-section', true);

		const statSection = document.querySelector('.stat-section') as HTMLElement;		
		const statCondensedSection = document.querySelector('.stats-condensed') as HTMLElement;		

		const buttons = statSection?.querySelectorAll('.button-list a');
		buttons?.forEach(button => {
			button.addEventListener('click',
				(e) => {
					e.preventDefault();
				

					const htmlElement = e.target as HTMLElement;
					buttons.forEach(b => b.classList.remove('active'));
					htmlElement.classList.add('active');

					
				
					
					statSection.querySelectorAll('.button-content')
						.forEach(a => a.classList.remove('active'));
					
					statSection.querySelectorAll('.circle-stats')
						.forEach(a => a.classList.remove('active'));

					statSection.querySelectorAll('.stat-item')
						.forEach(a => a.classList.remove('active'));

					let newbg = "";
					let statElements: NodeListOf<Element>;
					
					if (statCondensedSection) {
						const statItem = statSection.querySelector(`.stat-item${htmlElement.dataset.toggle}`) as HTMLElement;
						statItem?.classList.toggle('active');
						newbg = statItem.dataset.bg;
						statElements = statItem.querySelectorAll('.stat .number');
					} else {
						const currentCircleStats = statSection.querySelector(`.circle-stats${htmlElement.dataset.toggle}`) as HTMLElement;
						const buttonContent = statSection.querySelector(`.button-content${htmlElement.dataset.toggle}`);
						currentCircleStats?.classList.toggle('active');
						buttonContent?.classList.toggle('active');
						newbg = currentCircleStats.dataset.bg;
						statElements = currentCircleStats.querySelectorAll('.stat .number');
					}

				
					statSection.style.backgroundImage = `url('${newbg}')`;

					if (!Helpers.isEditScreen) {
						self.animateCircleStats(statElements);
					}
				});
		});

	
		window.addEventListener("scroll",
			() => {
				
					if (Helpers.elementIsInView(statSection as HTMLElement,7)) {
						const statElements = document.querySelectorAll('.circle-stats.active .stat .number');
						self.animateCircleStats(statElements);
					}
				
			});
	}

	animateCircleStats(statElements: NodeListOf<Element>) {

		statElements?.forEach(elStat => {
			const element = elStat as HTMLElement;
			if (!element.classList.contains('done')) {
				const endNum = parseInt(element.innerText);
				
				new AnimatedNumber(element, 1, endNum, 900);
				element.classList.add('done');
			}
		});
	}
}